import { Button, Dropdown, MenuProps } from 'antd';
import React, { ReactNode } from 'react';

interface IProps {
    icon: ReactNode;
    title: string;
    items: MenuProps['items'];
    onChange: MenuProps['onClick'];
    menuClassName?: string;
    btnClassName?: string;
    disabled?: boolean;
}
const BtnDropdown: React.FC<IProps> = ({
    icon,
    title,
    items,
    onChange,
    menuClassName = '',
    btnClassName = '',
    disabled,
}) => {
    return (
        <Dropdown
            disabled={disabled}
            menu={{
                items,
                onClick: onChange,
                className: menuClassName,
            }}
            trigger={['click']}
        >
            <Button
                type="text"
                style={{ borderColor: 'rgba(217, 217, 217, 1)' }}
                className={`!border !rounded-md !flex !items-center ${btnClassName}`}
            >
                {icon}
                {title}
            </Button>
        </Dropdown>
    );
};

export default BtnDropdown;
